import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Scales image to COVER the area and still maintain aspect ratio. (Part of the image might be hidden)
class Image extends React.Component {

    static propTypes = {
        src: PropTypes.string.isRequired,
        size: PropTypes.string.isRequired,
        circle: PropTypes.bool,
        whiteIfNoImage: PropTypes.bool,
        srcIfNoImage: PropTypes.string
    };

    static defaultProps = {
        circle: false,
        whiteIfNoImage: false,
        srcIfNoImage: null
    };

    constructor(props) {
        super(props);
        this.state = {
            isImageLoaded: false, // whether image dimensions has been determined
            isLoadError: false, // true if no image
            width: -1,  // original image width
            height: -1  // original image height
        };
    }

    componentWillMount() {
        const isOnServer = typeof(window) === "undefined";
        if (!isOnServer)
            this.determineImageSize(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.src !== this.props.src || nextProps.system.imageCacheBreaker !== this.props.system.imageCacheBreaker)
            this.determineImageSize(nextProps);
    }

    determineImageSize = (newestProps) => {
        // Create an in-memory image to determine its width and height
        const src = newestProps.src;
        const imageCacheBreaker = newestProps.system.imageCacheBreaker;
        const src_cache = this.addCacheBreakerToSrc(src, imageCacheBreaker);

        const img = document.createElement("img");
        img.onload = () => {
            if (this.props.src !== src || this.props.system.imageCacheBreaker !== imageCacheBreaker) return; // abort if src was changed while loading (or the cacheBreaker)
            this.setState({isImageLoaded: true, isLoadError: false, width: img.naturalWidth, height: img.naturalHeight});
        };
        img.onerror = error => {
            if (this.props.src !== src || this.props.system.imageCacheBreaker !== imageCacheBreaker) return; // abort if src was changed while loading (or the cacheBreaker)
            this.setState({isImageLoaded: false, isLoadError: true, width: -1, height: -1});
        };
        img.src = src_cache; // just to be safe: setting it after onload
    };

    sizeNameToPixels = () => { // Contains the standard sizes we use
        switch (this.props.size) {
            case "big": return 182;
            //case "normal": return 100;
            case "small": return 50;
            case "tiny": return 25;
            default: console.error("illegal size "+this.props.size); return 0;
        }
    };

    addCacheBreakerToSrc = (src, imageCacheBreaker) => {
        if (!src || src.substr(0,Math.min(5, src.length)) === "data:") // if src contains a "data:" url, don't add anything to it.
            return src;
        const separator = src.indexOf("?") === -1 ? "?" : "&";
        return src + separator + imageCacheBreaker;
    };

    render() {
        const { isImageLoaded, isLoadError, width, height } = this.state;
        const { src, circle, whiteIfNoImage, srcIfNoImage } = this.props;

        const sizePixels = this.sizeNameToPixels();

        const imgStyle = {
            visibility: isImageLoaded ? "visible" : "hidden",
        };

        const containerStyle = {
            width: sizePixels,
            height: sizePixels,
            //backgroundColor:"green",
            borderRadius: circle ? sizePixels/2 : 0
        };

        if (isLoadError && whiteIfNoImage)
            containerStyle.backgroundColor = "white";

        const src_cache = this.addCacheBreakerToSrc(src, this.props.system.imageCacheBreaker);

        const imageElement = width < height
            ? <img src={src_cache} width ={sizePixels} className="image-box-center-y" style={imgStyle} />
            : <img src={src_cache} height={sizePixels} className="image-box-center-x" style={imgStyle} />;

        const noImageElement = srcIfNoImage === null ? [] : <img src={srcIfNoImage} width={sizePixels} />;

        return (
            <div className="image-box" style={containerStyle}>
                {isLoadError ? noImageElement : imageElement}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    system: {
        imageCacheBreaker: state.system.imageCacheBreaker
    }
});

export default connect(mapStateToProps)(Image);



// WEBPACK FOOTER //
// ./src/client/src/components/reusable/image/Image.js